import { render, staticRenderFns } from "./monetaryMultiAccountModal.vue?vue&type=template&id=0a4a4f4c&scoped=true&"
import script from "./monetaryMultiAccountModal.vue?vue&type=script&lang=js&"
export * from "./monetaryMultiAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a4f4c",
  null
  
)

export default component.exports